import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'projectCovers',
  urlRoot: '/project_covers'
})
